import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import CSSModules from 'react-css-modules';
import styles from './app.module.css';
import Layout from './components/Layout/layout';
import About from './pages/About/about';
import RoadMap from './pages/Roadmap/roadmap';
import Benefits from './pages/Benefits/benefits';
import Faq from './pages/FAQ/faq';
import Community from './pages/Community/community';
import Investors from './pages/Investors/investors';
import Contact from './pages/Contact/contact';
import Puffer from './pages/Drop/puffer';
import Biker from './pages/Drop/biker';
import Bomber from './pages/Drop/bomber';
import Landscape from './pages/Cabana/landscape';
import Connect from './pages/Connect/connect.jsx';

const options = { allowMultiple: true };

function App() {
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [mainPage, setMainPage] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
      setMainPage(true);
    }, 5000);
  }, []);
  return (
    <div styleName="main-container">
      {!mainPage && loaderStatus && (
        <div styleName="loader-bg">
          <div styleName="loader-container">
            <div styleName="logo">
              <svg
                viewBox="0 0 272 272"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M34.9002 90.0853C45.7699 87.7966 56.9257 90.3714 64.6488 98.3816L88.1045 121.84L121.572 88.3688L98.116 64.9103C90.3928 57.1862 87.8184 46.0291 90.1068 35.1581C92.3951 24.001 88.1045 11.6996 77.2348 4.83371C67.7953 -1.74611 54.9233 -1.46003 45.4839 4.83371C35.7584 11.6996 31.4677 22.5706 32.8979 32.8695C22.6003 31.4391 11.7307 35.7302 5.15165 45.4569C-1.42737 54.8975 -1.71341 67.485 4.57956 77.2117C11.7307 88.0827 23.7445 92.3739 34.9002 90.0853Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M236.845 181.629C225.975 183.918 214.82 181.343 207.096 173.619L183.641 150.16L149.888 183.632L173.343 207.09C181.066 214.814 183.641 225.971 181.638 236.842C179.35 247.999 183.641 260.301 194.51 267.453C203.95 273.747 216.822 273.461 226.261 266.881C235.987 260.301 239.991 249.43 238.847 239.131C249.145 240.561 260.015 236.27 266.594 226.544C273.173 217.103 273.173 204.229 267.166 194.789C260.015 183.632 248.001 179.34 236.845 181.629Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M207.098 98.0947C214.822 90.3706 225.977 87.7959 236.847 90.0845C248.003 92.3731 260.303 88.0819 267.454 77.2109C273.747 67.7703 273.461 54.8968 266.882 45.4562C260.017 35.7295 249.147 31.4383 238.849 32.8687C240.28 22.5698 235.989 11.6988 226.263 5.11903C216.824 -1.46079 204.238 -1.74687 194.512 4.54687C183.643 11.6988 179.352 24.0002 181.641 35.1573C183.929 46.0283 181.354 57.1854 173.631 64.9095L64.9345 173.62C57.2113 181.344 46.0556 183.918 35.1859 181.63C24.0302 179.341 11.7302 183.632 4.57914 194.503C-1.71383 204.23 -1.42778 216.818 4.86519 226.258C11.7302 235.985 22.5999 240.276 32.8975 238.846C31.4673 249.144 35.758 260.015 45.4835 266.595C54.9229 273.175 67.7949 273.175 77.2344 267.167C88.104 260.015 92.3947 247.714 90.1064 236.557C87.818 225.686 90.3924 214.529 98.1156 206.805L207.098 98.0947Z"
                  fill="white"
                />
              </svg>
            </div>

            <div styleName="brand-name">
              <svg
                viewBox="0 0 1185 132"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M97.2209 63.3C108.021 57.72 114.141 48 114.141 35.94C114.141 16.5 97.9409 2.99999 64.8209 2.99999H0.380884V129H68.4209C102.261 129 120.261 116.22 120.261 94.44C120.261 79.14 111.441 68.34 97.2209 63.3ZM60.1409 28.74C72.0209 28.74 78.1409 32.88 78.1409 40.8C78.1409 48.9 72.0209 53.04 60.1409 53.04H35.6609V28.74H60.1409ZM65.5409 103.26H35.6609V77.7H65.5409C77.7809 77.7 84.2609 81.84 84.2609 90.48C84.2609 99.12 77.7809 103.26 65.5409 103.26ZM198.661 131.52C238.981 131.52 268.681 103.8 268.681 66C268.681 28.2 238.981 0.479992 198.661 0.479992C158.341 0.479992 128.641 28.2 128.641 66C128.641 103.8 158.341 131.52 198.661 131.52ZM198.661 102C179.581 102 164.641 87.78 164.641 66C164.641 44.22 179.581 30 198.661 30C217.741 30 232.681 44.22 232.681 66C232.681 87.78 217.741 102 198.661 102ZM368.707 2.99999V70.14L313.087 2.99999H283.747V129H318.667V61.86L374.287 129H403.627V2.99999H368.707ZM460.447 101.46V78.42H516.427V51.78H460.447V30.54H523.987V2.99999H425.167V129H526.327V101.46H460.447ZM626.744 2.99999V50.34H578.144V2.99999H542.504V129H578.144V79.86H626.744V129H662.384V2.99999H626.744ZM719.204 101.46V78.42H775.184V51.78H719.204V30.54H782.744V2.99999H683.924V129H785.084V101.46H719.204ZM895.581 129H932.661L876.861 2.99999H841.761L786.141 129H822.501L832.401 104.52H885.681L895.581 129ZM842.841 78.24L859.041 37.92L875.241 78.24H842.841ZM939.165 129H998.745C1040.51 129 1069.13 104.7 1069.13 66C1069.13 27.3 1040.51 2.99999 998.745 2.99999H939.165V129ZM974.805 100.56V31.44H997.305C1018.73 31.44 1033.13 44.22 1033.13 66C1033.13 87.78 1018.73 100.56 997.305 100.56H974.805ZM1128.56 131.52C1166 131.52 1184.36 112.8 1184.36 90.84C1184.36 44.4 1112.9 58.8 1112.9 39.54C1112.9 33.24 1118.3 28.2 1133.24 28.2C1144.22 28.2 1156.1 31.44 1168.16 37.92L1179.14 11.46C1166.72 4.26 1149.8 0.479992 1133.42 0.479992C1095.98 0.479992 1077.62 18.84 1077.62 41.34C1077.62 88.14 1149.26 73.56 1149.26 93.54C1149.26 99.66 1143.5 103.8 1128.74 103.8C1114.16 103.8 1098.32 98.76 1087.16 91.38L1075.46 117.66C1087.34 125.94 1107.86 131.52 1128.56 131.52Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
      {mainPage && (
        <div styleName="page-container fade-effect">
          <Router>
            <Switch>
              <Route path={`${process.env.PUBLIC_URL}/about`}>
                <Layout>
                  <About />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/roadmap`}>
                <Layout>
                  <RoadMap />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/benefits`}>
                <Layout>
                  <Benefits />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/faq`}>
                <Layout>
                  <Faq />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/community`}>
                <Layout>
                  <Community />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/investors`}>
                <Layout>
                  <Investors />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/contact`}>
                <Layout>
                  <Contact />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/store`}>
                <Layout>
                  <Landscape />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/connect`}>
                <Layout>
                  <Connect />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/puffer`}>
                <Layout>
                  <Puffer />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/biker`}>
                <Layout>
                  <Biker />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/bomber`}>
                <Layout>
                  <Bomber />
                </Layout>
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/`}>
                <Redirect to="/connect" />
                {/* <Layout>
                  <Home />
                </Layout> */}
              </Route>
            </Switch>
          </Router>
        </div>
      )}
    </div>
  );
}

export default CSSModules(App, styles, options);
